// Translations for HorsIndex — FR (default) + EN
// Structure mirrors section keys for easy lookup.

export const translations = {
  fr: {
    common: {
      brand: "HorsIndex",
      tagline: "Réduction de l'exposition numérique professionnelle et patrimoniale",
      ctaDiagnostic: "Demander un audit initial",
      ctaDiagnosticShort: "Audit initial",
      ctaApproach: "Voir la méthode",
      back: "Retour",
      legaltechEU: "Legaltech européenne",
    },
    nav: {
      etat: "État des lieux",
      methode: "Méthode",
      droits: "Cadre juridique",
      services: "Services",
      outil: "Outil interne",
      structure: "Structure",
      ressources: "Ressources",
      comprendre: "Comprendre",
      accueil: "Accueil",
      menu: "Menu",
    },
    hero: {
      eyebrow: "Initiative française pensée pour le cadre européen",
      titlePre: "Protéger vos ",
      titleEm: "informations",
      titlePost: " en ligne.",
      description:
        "HorsIndex intervient sur les informations personnelles et professionnelles accessibles sur Google et d'autres sites : les retirer, les masquer ou réduire leur visibilité lorsque cela est possible.",
      nameExplanation: "",
      disclaimer:
        "HorsIndex ne promet pas l'effacement de toute information dans tous les systèmes. L'accompagnement vise à réduire l'exposition publique évitable, c'est-à-dire les informations que n'importe qui peut découvrir sans compte, sans abonnement et sans motif particulier, lorsque des démarches sont possibles.",
      indexation: "Indexation",
      desindexation: "Désindexation",
    },
    etat: {
      eyebrow: "01 / Constat",
      titlePre: "Pourquoi vos informations ",
      titleEm: "se retrouvent",
      titlePost: " partout en ligne.",
      p1:
        "Les données liées aux dirigeants, mandats sociaux, sociétés, structures patrimoniales et activités professionnelles sont aujourd'hui largement reprises, agrégées, indexées et rediffusées sur internet. Les informations initialement publiées dans le cadre de registres officiels circulent désormais bien au-delà de leur finalité administrative d'origine.",
      p2:
        "Cette exposition résulte de la multiplication des agrégateurs privés, de la réutilisation des données open data, de l'indexation par les moteurs de recherche et des logiques de référencement automatisé. Une même information peut ainsi apparaître simultanément sur de nombreux sites, parfois enrichie, dupliquée ou sortie de son contexte initial.",
      chainLabel: "Chaîne de circulation",
      chain: [
        { title: "Registres officiels", desc: "Les données sont d'abord publiées dans un cadre administratif ou légal." },
        { title: "Bases open data", desc: "Elles sont ensuite rendues accessibles sous forme de jeux de données réutilisables." },
        { title: "Agrégateurs privés", desc: "Des plateformes les récupèrent, les retraitent et les republient." },
        { title: "Fiches dirigeants", desc: "Les informations sont associées à des personnes physiques identifiables." },
        { title: "Résultats Google", desc: "Les pages rediffusées deviennent visibles dans les moteurs de recherche." },
        { title: "SCI et structures patrimoniales", desc: "Certaines structures exposent indirectement une adresse, un mandat ou une situation familiale." },
        { title: "Rediffusions multiples", desc: "Une même information peut apparaître sur plusieurs sites simultanément." },
        { title: "Indexations automatiques", desc: "Les reprises successives rendent l'exposition difficile à maîtriser." },
      ],
      transition:
        "« HorsIndex part de ce constat : le sujet n'est pas uniquement l'existence des données publiques, mais leur transformation en une exposition publique générale, nominative, indexée, téléchargeable et immédiatement exploitable. »",
    },
    probleme: {
      eyebrow: "02 / Problème",
      titlePre: "Une exposition ",
      titleEm: "souvent",
      titlePost: " bien plus large que les registres officiels.",
      p1:
        "Certaines informations liées aux dirigeants, associés ou structures patrimoniales deviennent extrêmement visibles en ligne alors même qu'elles proviennent initialement de formalités administratives ou de publications légales limitées.",
      p2:
        "Les reprises privées, les moteurs internes, les indexations Google et les systèmes d'agrégation automatisée peuvent conduire à une exposition durable, extensive et difficilement maîtrisable.",
    },
    methode: {
      eyebrow: "03 / Approche",
      titlePre: "Une approche ",
      titleEm: "structurée.",
      titlePost: "",
      blocs: [
        { num: "I", title: "Cartographier", text: "Identifier les sources, les URL, les sociétés, les mandats et les reprises visibles en ligne." },
        { num: "II", title: "Qualifier", text: "Distinguer les registres officiels des rediffusions privées et identifier les leviers disponibles." },
        { num: "III", title: "Agir", text: "Préparer les demandes fondées sur les droits RGPD adaptés : accès, rectification, opposition, limitation, effacement ou désindexation, selon la nature de la source et la situation de la personne concernée." },
        { num: "IV", title: "Documenter", text: "Organiser les preuves, suivre les réponses et préparer les relances éventuelles." },
      ],
    },
    droits: {
      eyebrow: "04 / Droits",
      titlePre: "Des droits RGPD ",
      titleEm: "mobilisés",
      titlePost: " selon chaque situation.",
      intro:
        "HorsIndex ne traite pas toutes les situations de la même manière. Chaque source est d'abord qualifiée afin d'identifier les droits réellement mobilisables : accès, rectification, opposition, limitation, effacement ou désindexation. L'objectif est d'utiliser le bon levier, auprès du bon acteur, avec une demande documentée.",
      tag: "RGPD",
      cartes: [
        { title: "Droit d'accès", text: "Demander quelles données personnelles sont traitées, d'où elles proviennent, à quelles fins elles sont utilisées et sur quelle base juridique elles reposent." },
        { title: "Droit de rectification", text: "Corriger les données inexactes, incomplètes ou obsolètes, notamment lorsqu'une fonction, une adresse, un mandat ou une situation juridique est mal présentée." },
        { title: "Droit d'opposition", text: "Contester certaines réutilisations de données personnelles lorsqu'elles reposent sur un intérêt légitime privé et que la situation particulière de la personne justifie une opposition." },
        { title: "Droit à la limitation", text: "Demander le gel temporaire de certains traitements pendant l'examen d'une contestation, notamment lorsque les données sont discutées ou que leur usage paraît excessif." },
        { title: "Droit à l'effacement", text: "Demander la suppression de certaines données lorsque les conditions sont réunies, en particulier en cas de traitement injustifié, excessif, obsolète ou non conforme." },
        { title: "Désindexation", text: "Demander, lorsque cela est possible, la réduction de visibilité d'une page dans les moteurs de recherche ou dans le moteur interne d'un site, sans nécessairement supprimer la page source." },
      ],
      prudence:
        "Ces droits ne produisent pas tous les mêmes effets et ne sont pas toujours applicables aux registres officiels. HorsIndex distingue donc les sources publiques, les obligations légales et les rediffusions privées avant toute démarche.",
    },
    outil: {
      eyebrow: "05 / Outil propriétaire",
      titlePre: "Un outil interne ",
      titleEm: "fondé",
      titlePost: " sur les données officielles.",
      p1Pre:
        "HorsIndex développe un outil interne exploitant notamment les données ",
      p1Mid: " et ",
      p1Post:
        " afin de mieux identifier les sociétés, mandats, structures patrimoniales et reprises associées à une personne physique.",
      p2: "Cet outil permet de construire une cartographie plus rigoureuse des situations d'exposition et de comparer les données issues des registres officiels avec leurs rediffusions visibles sur internet.",
      note: "L'outil n'est pas destiné au public à ce stade. Il sert à structurer les diagnostics, qualifier les situations et préparer les actions adaptées.",
      tag: "Cartographie",
      caption: "Outil interne",
      captionRight: "Non destiné au public",
      sourcesBadge: "INPI · INSEE",
      mockup: {
        chrome: "Interface interne : Cartographie",
        version: "v.0.1",
        sourceLabel: "Source officielle",
        sourceValue: "INPI · INSEE · RCS",
        exposureLabel: "Niveau d'exposition",
        exposureHigh: "Élevé",
        exposureMedium: "Modéré",
        exposureLow: "Faible",
        colPlatform: "Plateforme",
        colStatus: "Statut",
        colIndex: "Indexation",
        statusOfficial: "Source officielle",
        statusReuse: "Rediffusion privée",
        statusIndex: "Indexation",
        actionLabel: "Action envisageable",
        actionDocument: "Documenter",
        actionQualify: "Qualifier",
        actionPrioritize: "Prioriser",
      },
    },
    pourQui: {
      eyebrow: "06 / Périmètre",
      titlePre: "Pour ",
      titleEm: "qui ?",
      titlePost: "",
      sub:
        "Personnes physiques exposées par leurs mandats, leurs sociétés ou leurs structures patrimoniales.",
      categories: [
        "Dirigeants",
        "Anciens dirigeants",
        "Associés",
        "Indépendants",
        "SCI familiales",
        "Structures patrimoniales",
        "Mandataires sociaux",
      ],
    },
    collab: {
      eyebrow: "07 / Gouvernance",
      titlePre: "Un projet porté avec un ",
      titleEm: "appui juridique.",
      titlePost: "",
      labelPorteur: "Porteur",
      porteurName: "Simon Marie",
      porteurRole: "Consultant conformité & RGPD",
      labelCollab: "Collaboration",
      collabName: "Avocat partenaire",
      collabRole: "Validation spécifique",
      p1:
        "HorsIndex est initié par Simon Marie, consultant en conformité réglementaire et protection des données personnelles. Le service est destiné à être porté par la structure d'appui, structure française conçue pour développer des services, outils et méthodes liés aux données, aux pratiques numériques, à la conformité réglementaire et à la réduction de l'exposition numérique.",
      p2:
        "Le service ne se substitue pas à un avocat. Il vise à structurer les informations, qualifier les situations d'exposition, préparer les démarches et organiser les pièces utiles. Lorsque la situation nécessite une appréciation juridique individualisée, une mise en demeure ou une démarche contentieuse, le dossier peut être orienté vers un avocat partenaire.",
    },
    structure: {
      eyebrow: "08 / Structure",
      titlePre: "Une structure française ",
      titleEm: "pensée",
      titlePost: " pour évoluer.",
      p1:
        "HorsIndex est un service en phase d'incubation au sein de la structure d'appui. La société porte la structuration du projet, ses contenus, ses méthodes, ses outils internes et les développements numériques liés à la réduction de l'exposition numérique professionnelle et patrimoniale.",
      p2:
        "Cette structure a vocation à porter les actifs du projet, les outils internes, les contenus, les méthodes, les automatisations, les contrats, les développements numériques et les partenariats liés au service.",
      p3:
        "Le choix d'une structure française permet de maintenir une base lisible, cohérente avec le lieu de lancement du projet et adaptée à une première phase centrée sur le marché français. Une évolution ultérieure restera possible si le service prend une dimension plus large.",
      diag: {
        labelEditor: "Structure support",
        editor: "la structure d'appui",
        editorLoc: "France",
        labelBrand: "Service",
        brand: "HorsIndex",
        labelMission: "Mission",
        mission:
          "Réduction de l'exposition numérique professionnelle et patrimoniale",
      },
      levelsLabel: "Organisation",
      levels: [
        {
          eyebrow: "Structure support",
          title: "la structure d'appui",
          desc: "Société française porteuse du projet, des actifs, des contrats et des développements numériques liés au service.",
          tag: "France",
        },
        {
          eyebrow: "Service",
          title: "HorsIndex",
          desc: "Service dédié à la réduction de l'exposition numérique professionnelle et patrimoniale.",
          tag: "Marque INPI",
        },
        {
          eyebrow: "Méthode",
          title: "Cartographier, qualifier, documenter, orienter",
          desc: "Une méthode structurée pour identifier les sources, distinguer les obligations légales des rediffusions privées et préparer des démarches documentées.",
          tag: "RGPD",
        },
        {
          eyebrow: "Appui juridique",
          title: "Avocat partenaire",
          desc: "Lorsque la situation appelle une appréciation individualisée, une mise en demeure ou une démarche contentieuse, le dossier peut être orienté.",
          tag: "Sur sollicitation",
        },
      ],
      invest: {
        eyebrow: "Ouverture",
        title: "Ouverture à des associés ou investisseurs",
        text:
          "HorsIndex peut évoluer avec des associés, partenaires ou investisseurs partageant une approche prudente des données, de la conformité et de l'exposition numérique. L'objectif n'est pas de créer un service spectaculaire, mais une structure utile, documentée et juridiquement maîtrisée, capable de répondre à un problème devenu massif.",
        cta: "Discuter du projet",
      },
    },
    cadre: {
      eyebrow: "09 / Cadre",
      titlePre: "Un cadre ",
      titleEm: "volontairement",
      titlePost: " prudent.",
      p1:
        "HorsIndex ne promet pas l'effacement total des données publiques ni l'invisibilité numérique. Le service vise à réduire les reprises excessives, corriger certaines situations problématiques et encadrer les rediffusions privées lorsque des leviers juridiques existent.",
      p2:
        "Les registres officiels, obligations légales de publication et intérêts légitimes applicables sont systématiquement distingués des usages privés, des reprises automatisées et des logiques d'indexation extensive.",
    },
    contact: {
      eyebrow: "10 / Contact",
      titlePre: "Demander un ",
      titleEm: "premier",
      titlePost: " échange.",
      intro:
        "Décrivez brièvement votre situation. HorsIndex revient vers vous pour qualifier la demande et proposer, le cas échéant, un audit initial adapté.",
      labelConf: "Confidentialité",
      confText:
        "Les informations transmises sont utilisées uniquement pour qualifier votre demande et préparer un premier échange. Elles ne sont pas revendues ni communiquées à des tiers commerciaux.",
      fields: {
        nom: "Nom",
        email: "E-mail",
        message: "Message",
        url: "URL concernée (facultatif)",
      },
      placeholders: {
        nom: "Votre nom",
        email: "adresse@domaine.com",
        url: "https://…",
        message: "Décrivez brièvement votre situation.",
      },
      submit: "Être recontacté",
      submitting: "Envoi…",
      legal:
        "Les informations transmises via ce formulaire sont utilisées uniquement pour traiter votre demande. Elles ne sont pas revendues, ni utilisées à des fins de prospection automatisée. Vous pouvez demander l'accès, la rectification ou la suppression de vos données à l'adresse contact@horsindex.com.",
      successTitle: "Votre demande a bien été reçue.",
      successText:
        "HorsIndex revient vers vous prochainement à l'adresse indiquée. Toutes les informations transmises restent strictement confidentielles.",
      newRequest: "Nouvelle demande",
      toastSuccess: "Demande transmise. Une réponse vous parviendra prochainement.",
      toastError: "Une erreur est survenue. Merci de réessayer.",
      toastRequired: "Merci de renseigner votre nom, e-mail et message.",
      ctaDeep: "Demande approfondie",
      ctaDeepDesc:
        "Pour une situation plus complexe, avec des mandats multiples, plusieurs sociétés ou de nombreuses URL, accédez au formulaire enrichi.",
      ctaDeepLink: "Lecture approfondie",
    },
    footer: {
      tagline: "Réduction de l'exposition numérique professionnelle et patrimoniale.",
      legalNote:
        "HorsIndex est le service. la structure d'appui est la structure française destinée à le porter.",
      nav: "Navigation",
      info: "Informations",
      domain: "Domaine",
      rights: "HorsIndex, marque française déposée. Tous droits réservés",
      location: "France",
      mentions: "Mentions légales",
      politique: "Politique de confidentialité",
      contact: "Contact",
      simonMarie: "Simon Marie",
      anchorFr: "Conçu en France",
      anchorEu: "Pensé pour le cadre européen",
    },
    math: {
      label: "Vérification",
      refresh: "Nouvelle question",
      help: "Cette vérification permet d'éviter les soumissions automatisées.",
      error: "Réponse incorrecte. Merci de vérifier le calcul.",
    },
    diagnostic: {
      pageEyebrow: "Audit initial",
      pageTitlePre: "Audit ",
      pageTitleEm: "initial",
      pageTitlePost: ".",
      intro:
        "Ce formulaire est le point d'entrée. Décrivez votre situation en quelques lignes : HorsIndex examine ce qui est accessible à votre sujet, évalue si une démarche est pertinente et prépare un premier échange. Les informations transmises restent confidentielles. Plus elles sont précises, plus le premier examen sera utile.",
      step1: "Identité",
      step2: "Périmètre professionnel",
      step3: "Informations repérées en ligne",
      step4: "Contexte & priorités",
      fields: {
        nom: "Nom",
        prenom: "Prénom",
        email: "Adresse e-mail",
        telephone: "Téléphone (facultatif)",
        qualite: "Qualité",
        mandats: "Mandats sociaux",
        societes: "Sociétés concernées",
        urls: "Adresses (URL) des pages concernées",
        contexte: "Contexte & objectifs",
        urgence: "Niveau d'urgence",
      },
      placeholders: {
        nom: "Votre nom",
        prenom: "Votre prénom",
        email: "adresse@domaine.com",
        telephone: "+33 …",
        societe: "Raison sociale ou SIREN",
        mandat: "Ex. Président, Gérant, Associé majoritaire…",
        url: "https://…",
        contexte:
          "Décrivez la situation, vos objectifs, les éléments problématiques observés, les actions déjà entreprises…",
      },
      qualites: [
        "Dirigeant en exercice",
        "Ancien dirigeant",
        "Associé / Actionnaire",
        "Indépendant",
        "Mandataire social",
        "Représentant de SCI / structure patrimoniale",
        "Autre",
      ],
      urgences: [
        "Standard : pas d'enjeu immédiat",
        "Élevé : situation préoccupante",
        "Critique : exposition récente ou pression médiatique",
      ],
      add: "Ajouter",
      remove: "Retirer",
      consent:
        "J'accepte que les informations transmises soient utilisées pour étudier ma demande et préparer un échange préalable. Aucune donnée n'est communiquée à des tiers commerciaux.",
      submit: "Envoyer la demande",
      submitting: "Transmission…",
      legal:
        "Les informations transmises via ce formulaire sont utilisées uniquement pour traiter votre demande. Elles ne sont pas revendues, ni utilisées à des fins de prospection automatisée. Vous pouvez demander l'accès, la rectification ou la suppression de vos données à l'adresse contact@horsindex.com.",
      successTitle: "Demande transmise.",
      successText:
        "Votre demande a bien été reçue. HorsIndex revient vers vous dans un délai raisonnable pour proposer un premier échange et indiquer les démarches envisageables dans votre situation.",
      backHome: "Retour à l'accueil",
      newRequest: "Nouvelle demande",
      toastSuccess: "Demande transmise avec succès.",
      toastError: "Une erreur est survenue. Merci de réessayer.",
      toastRequired: "Merci de renseigner au minimum votre nom, e-mail et contexte.",
      toastConsent: "Merci d'accepter les conditions de traitement.",
      hint: "Vous pouvez ajouter plusieurs entrées si nécessaire.",
    },
  },

  en: {
    common: {
      brand: "HorsIndex",
      tagline: "Reducing professional and asset-related digital exposure",
      ctaDiagnostic: "Request an initial assessment",
      ctaDiagnosticShort: "First review",
      ctaApproach: "Our approach",
      back: "Back",
      legaltechEU: "European legaltech",
    },
    nav: {
      etat: "Overview",
      methode: "Method",
      droits: "Legal framework",
      services: "Services",
      outil: "Internal tool",
      structure: "Structure",
      ressources: "Resources",
      comprendre: "Understand",
      accueil: "Home",
      menu: "Menu",
    },
    hero: {
      eyebrow: "European legaltech",
      titlePre: "Reducing ",
      titleEm: "professional & asset-related",
      titlePost: " digital exposure.",
      description:
        "HorsIndex helps executives, independents, associates, former corporate officers and asset-holding entities identify, qualify and reduce excessive reuse of their personal data online.",
      nameExplanation:
        "\u201CHorsIndex\u201D means \u201Coutside the index\u201D. The name reflects the aim of the project: reducing unnecessary digital exposure by helping professionals and patrimonial structures become less exposed to excessive indexing, aggregation and reuse of personal or corporate information online.",
      disclaimer:
        "We do not promise the complete erasure of public data. We help reduce avoidable exposure where legitimate levers exist.",
      indexation: "Indexing",
      desindexation: "De-indexing",
    },
    etat: {
      eyebrow: "01 / Reality",
      titlePre: "Exposure has ",
      titleEm: "become",
      titlePost: " massive.",
      p1:
        "Data linked to executives, corporate mandates, companies, asset-holding structures and professional activities is now widely reused, aggregated, indexed and redistributed online. Information originally published within official registries now circulates well beyond its initial administrative purpose.",
      p2:
        "This exposure stems from the proliferation of private aggregators, the reuse of open data, search engine indexing and automated referencing logic. The same piece of information can appear simultaneously on numerous sites, enriched, duplicated or taken out of its original context.",
      chainLabel: "Circulation chain",
      chain: [
        { title: "Official registries", desc: "Data is first published within an administrative or legal framework." },
        { title: "Open data sources", desc: "It is then made available as reusable data sets." },
        { title: "Private aggregators", desc: "Platforms retrieve, reprocess and republish it." },
        { title: "Executive profiles", desc: "Information becomes attached to identifiable individuals." },
        { title: "Google results", desc: "Republished pages become visible across search engines." },
        { title: "Holdings & asset structures", desc: "Some entities indirectly expose an address, a mandate or a family situation." },
        { title: "Multiple republications", desc: "The same information may appear simultaneously on several sites." },
        { title: "Automated indexing", desc: "Successive reuses make the exposure difficult to control." },
      ],
      transition:
        "« HorsIndex starts from this observation: the issue is not merely the existence of public data, but its widespread distribution, indexing and sometimes disproportionate reuse. »",
    },
    probleme: {
      eyebrow: "02 / Issue",
      titlePre: "Exposure often extends ",
      titleEm: "far beyond",
      titlePost: " official registries.",
      p1:
        "Certain information regarding executives, associates or asset-holding structures becomes extremely visible online, even though it originates from limited administrative filings or legal publications.",
      p2:
        "Private reuse, internal search engines, Google indexing and automated aggregation systems can result in lasting, extensive and hard-to-control exposure.",
    },
    methode: {
      eyebrow: "03 / Approach",
      titlePre: "A ",
      titleEm: "structured approach.",
      titlePost: "",
      blocs: [
        { num: "I", title: "Map", text: "Identify sources, URLs, companies, mandates and visible reuses online." },
        { num: "II", title: "Qualify", text: "Distinguish official registries from private republications and identify the available levers." },
        { num: "III", title: "Act", text: "Prepare requests based on the appropriate GDPR rights: access, rectification, objection, restriction, erasure or de-indexing, according to the nature of the source and the situation of the data subject." },
        { num: "IV", title: "Document", text: "Organise evidence, track responses and prepare any follow-ups." },
      ],
    },
    droits: {
      eyebrow: "04 / Rights",
      titlePre: "GDPR rights ",
      titleEm: "deployed",
      titlePost: " according to each situation.",
      intro:
        "HorsIndex does not treat all situations the same way. Each source is first qualified to identify which rights can actually be invoked: access, rectification, objection, restriction, erasure or de-indexing. The goal is to use the right lever, against the right actor, with a properly documented request.",
      tag: "GDPR",
      cartes: [
        { title: "Right of access", text: "Request which personal data is processed, where it originates, for what purposes and on which legal basis." },
        { title: "Right to rectification", text: "Correct inaccurate, incomplete or outdated data, particularly when a role, address, mandate or legal situation is misrepresented." },
        { title: "Right to object", text: "Contest certain reuses of personal data based on a private legitimate interest, where the particular situation of the person justifies it." },
        { title: "Right to restriction", text: "Request the temporary suspension of certain processing operations while a contestation is examined, especially when the data is disputed or appears excessive." },
        { title: "Right to erasure", text: "Request deletion of certain data when conditions are met : in particular unjustified, excessive, outdated or non-compliant processing." },
        { title: "De-indexing", text: "Where possible, request reduced visibility of a page in search engines or in a site's internal search engine, without necessarily deleting the source page." },
      ],
      prudence:
        "These rights do not all produce the same effects and are not always applicable to official registries. HorsIndex therefore distinguishes public sources, legal publication obligations and private republications before any action.",
    },
    outil: {
      eyebrow: "05 / Proprietary tool",
      titlePre: "An internal tool ",
      titleEm: "grounded",
      titlePost: " in official data.",
      p1Pre:
        "HorsIndex is developing an internal tool that draws on ",
      p1Mid: "",
      p1Post:
        " : to better identify the companies, mandates, asset structures and republications associated with an individual.",
      p2: "The tool helps build a more rigorous map of exposure situations and compare data from official registries with their visible republications online.",
      note: "The tool is not intended for public use at this stage. It serves to structure diagnostics, qualify situations and prepare appropriate actions.",
      tag: "Mapping",
      caption: "Internal tool",
      captionRight: "Not intended for public use",
      sourcesBadge: "Official registries",
      mockup: {
        chrome: "Internal interface : Mapping",
        version: "v.0.1",
        sourceLabel: "Official source",
        sourceValue: "Business & corporate registries",
        exposureLabel: "Exposure level",
        exposureHigh: "High",
        exposureMedium: "Moderate",
        exposureLow: "Low",
        colPlatform: "Platform",
        colStatus: "Status",
        colIndex: "Indexing",
        statusOfficial: "Official source",
        statusReuse: "Private republication",
        statusIndex: "Indexing",
        actionLabel: "Suggested action",
        actionDocument: "Document",
        actionQualify: "Qualify",
        actionPrioritize: "Prioritise",
      },
    },
    pourQui: {
      eyebrow: "06 / Scope",
      titlePre: "Who is it ",
      titleEm: "for?",
      titlePost: "",
      sub:
        "Individuals exposed through their mandates, companies or asset-holding structures.",
      categories: [
        "Executives",
        "Former executives",
        "Associates",
        "Independents",
        "Family holdings",
        "Asset structures",
        "Corporate officers",
      ],
    },
    collab: {
      eyebrow: "07 / Governance",
      titlePre: "A project supported by ",
      titleEm: "legal expertise.",
      titlePost: "",
      labelPorteur: "Founder",
      porteurName: "Simon Marie",
      porteurRole: "Compliance & GDPR consultant",
      labelCollab: "Partnership",
      collabName: "Partner lawyer",
      collabRole: "Specific validation",
      p1:
        "HorsIndex is initiated by Simon Marie, a consultant in regulatory compliance and personal data protection. The service is intended to be carried by la structure d'appui, a French company designed to develop services, tools and methods related to data, digital practices, regulatory compliance and the reduction of digital exposure.",
      p2:
        "The service does not replace a lawyer. It helps structure information, qualify exposure situations, prepare requests and organise relevant evidence. Where a matter requires individual legal advice, a formal notice or a litigation strategy, the case may be referred to a partner lawyer.",
    },
    structure: {
      eyebrow: "08 / Structure",
      titlePre: "A French structure ",
      titleEm: "designed",
      titlePost: " to evolve.",
      p1:
        "HorsIndex is a service currently being incubated within la structure d'appui. The company oversees the structuring of the project, its content, methods, internal tools and digital developments related to the reduction of professional and patrimonial digital exposure.",
      p2:
        "This structure is intended to hold the project's assets, internal tools, content, methods, automations, contracts, digital developments and partnerships related to the service.",
      p3:
        "Choosing a French structure keeps the project clearly readable, consistent with its place of launch and adapted to a first phase focused on the French market. A later evolution remains possible should the service take on a broader dimension.",
      diag: {
        labelEditor: "Operating company",
        editor: "la structure d'appui",
        editorLoc: "France",
        labelBrand: "Service",
        brand: "HorsIndex",
        labelMission: "Mission",
        mission:
          "Reducing professional and asset-related digital exposure",
      },
      levelsLabel: "Organisation",
      levels: [
        {
          eyebrow: "Supporting structure",
          title: "la structure d'appui",
          desc: "French company carrying the project, its assets, contracts and digital developments related to the service.",
          tag: "France",
        },
        {
          eyebrow: "Service",
          title: "HorsIndex",
          desc: "Service dedicated to reducing professional and patrimonial digital exposure.",
          tag: "INPI trademark",
        },
        {
          eyebrow: "Method",
          title: "Map, qualify, document, guide",
          desc: "A structured method to identify sources, distinguish legal obligations from private republications and prepare properly documented requests.",
          tag: "GDPR",
        },
        {
          eyebrow: "Legal support",
          title: "Partner lawyer",
          desc: "A partner lawyer may be involved when the situation requires individual advice, a formal notice or a litigation strategy.",
          tag: "On request",
        },
      ],
      invest: {
        eyebrow: "Open",
        title: "Open to associates or investors",
        text:
          "HorsIndex can evolve with associates, partners or investors who share a cautious approach to data, compliance and digital exposure. The aim is not a spectacular service but a useful, documented and legally rigorous structure able to address a now massive problem.",
        cta: "Discuss the project",
      },
    },
    cadre: {
      eyebrow: "09 / Framework",
      titlePre: "A ",
      titleEm: "deliberately",
      titlePost: " cautious framework.",
      p1:
        "HorsIndex does not promise the complete erasure of public data nor digital invisibility. The service aims to reduce excessive reuse, correct certain problematic situations and frame private redistributions where legal levers exist.",
      p2:
        "Official registries, legal publication obligations and applicable legitimate interests are systematically distinguished from private uses, automated reuses and extensive indexing logic.",
    },
    contact: {
      eyebrow: "10 / Contact",
      titlePre: "Request a ",
      titleEm: "first",
      titlePost: " conversation.",
      intro:
        "Briefly describe your situation. We will get back to you to qualify your request and, where relevant, propose a tailored initial assessment.",
      labelConf: "Confidentiality",
      confText:
        "The information submitted is used solely to qualify your request and prepare an initial exchange. It is not sold or shared with commercial third parties.",
      fields: {
        nom: "Name",
        email: "Email",
        message: "Message",
        url: "Concerned URL (optional)",
      },
      placeholders: {
        nom: "Your name",
        email: "name@domain.com",
        url: "https://…",
        message: "Briefly describe your situation.",
      },
      submit: "Get in touch",
      submitting: "Sending…",
      legal:
        "By sending this form, you agree that your information will be used to process your request, in compliance with GDPR.",
      successTitle: "Your request has been received.",
      successText:
        "We will get back to you shortly at the address provided. All information transmitted remains strictly confidential.",
      newRequest: "New request",
      toastSuccess: "Request transmitted. We will get back to you shortly.",
      toastError: "An error occurred. Please try again.",
      toastRequired: "Please provide at least your name, email and message.",
      ctaDeep: "In-depth request",
      ctaDeepDesc:
        "For more complex situations, involving multiple mandates, several companies or many URLs, use our enriched form.",
      ctaDeepLink: "In-depth review",
    },
    footer: {
      tagline: "Reducing professional and asset-related digital exposure.",
      legalNote:
        "HorsIndex is the service. la structure d'appui is the French structure intended to operate it.",
      nav: "Navigation",
      info: "Information",
      domain: "Domain",
      rights: "HorsIndex, French trademark filed. All rights reserved",
      location: "France",
      mentions: "Legal notice",
      politique: "Privacy policy",
      contact: "Contact",
      simonMarie: "Simon Marie",
      anchorFr: "Built in France",
      anchorEu: "Designed for the European framework",
    },
    math: {
      label: "Verification",
      refresh: "New question",
      help: "This check prevents automated submissions.",
      error: "Incorrect answer. Please check the calculation.",
    },
    diagnostic: {
      pageEyebrow: "Initial assessment",
      pageTitlePre: "Initial ",
      pageTitleEm: "assessment",
      pageTitlePost: ".",
      intro:
        "This form helps us qualify your situation. The more precise the information, the more reliable the initial diagnostic. All fields are confidential and used solely to handle your request.",
      step1: "Identity",
      step2: "Professional perimeter",
      step3: "Observed exposure",
      step4: "Context & priorities",
      fields: {
        nom: "Last name",
        prenom: "First name",
        email: "Email address",
        telephone: "Phone (optional)",
        qualite: "Capacity",
        mandats: "Corporate mandates",
        societes: "Concerned companies",
        urls: "Observed exposure URLs",
        contexte: "Context & objectives",
        urgence: "Urgency level",
      },
      placeholders: {
        nom: "Your last name",
        prenom: "Your first name",
        email: "name@domain.com",
        telephone: "+33 …",
        societe: "Company name or registration number",
        mandat: "e.g. CEO, Manager, Majority shareholder…",
        url: "https://…",
        contexte:
          "Describe the situation, your objectives, problematic elements observed, actions already taken…",
      },
      qualites: [
        "Current executive",
        "Former executive",
        "Associate / Shareholder",
        "Independent",
        "Corporate officer",
        "Representative of a holding / asset structure",
        "Other",
      ],
      urgences: [
        "Standard : no immediate concern",
        "Elevated : concerning situation",
        "Critical : recent exposure or media pressure",
      ],
      add: "Add",
      remove: "Remove",
      consent:
        "I accept that the information transmitted will be used to qualify my request and prepare a preliminary exchange. No data is shared with commercial third parties.",
      submit: "Submit request",
      submitting: "Transmitting…",
      successTitle: "Request transmitted.",
      successText:
        "Your request has been received. We will get back to you within a reasonable time to propose a preliminary exchange and qualify the levers applicable to your situation.",
      backHome: "Back to home",
      newRequest: "New request",
      toastSuccess: "Request submitted successfully.",
      toastError: "An error occurred. Please try again.",
      toastRequired: "Please provide at least your name, email and context.",
      toastConsent: "Please accept the processing terms.",
      hint: "You can add multiple entries if needed.",
    },
  },
};

// Helper to fetch nested value by dot path: "hero.title"
export function getByPath(obj, path) {
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}
